import React from 'react'
import styled from 'styled-components'
import { calculateSellingPriceInclVatFormatted } from 'src/utils/vatCalculations'
import { formatRecipeCostPerPortionLabel } from 'src/utils/growthEngineRecipePrices'
import { formatGbp } from 'src/utils/formatGbp'
import RecipeGpBadge from './RecipeGpBadge'
import {
  GP_REVIEW_NO_PRICES_YET,
  recipeHasNoPricesYet,
} from 'src/utils/recipeGpReview'
import {
  isRecipeArchived,
  RECIPE_ARCHIVED_ROW_LABEL,
} from 'src/utils/recipeMonitoring'

const RecipeListItemDescription = ({
  recipe,
  useVatAwareSellingPrice = true,
}) => {
  const sellingPrice = useVatAwareSellingPrice
    ? calculateSellingPriceInclVatFormatted(
        recipe?.sellingPrice,
        recipe?.hasVat,
      ) ||
      recipe?.sellingPrice?.toFixed(2) ||
      0
    : recipe?.sellingPrice?.toFixed(2) || 0

  const costPerPortion = formatRecipeCostPerPortionLabel(recipe?.costPerPortion)

  if (isRecipeArchived(recipe)) {
    return (
      <DescriptionRow data-testid='recipe-archived-label'>
        {RECIPE_ARCHIVED_ROW_LABEL}
      </DescriptionRow>
    )
  }

  return (
    <DescriptionRow>
      <span>{formatGbp(sellingPrice)}</span>
      <Separator>|</Separator>
      <GpLabel>Gross Profit:</GpLabel>
      {recipeHasNoPricesYet(recipe) ? (
        <NoPricesYet>{GP_REVIEW_NO_PRICES_YET}</NoPricesYet>
      ) : (
        <ListGpBadge>
          <RecipeGpBadge grossProfit={recipe?.grossProfit} />
        </ListGpBadge>
      )}
      <Separator>|</Separator>
      <span>Cost Per Portion: {costPerPortion}</span>
    </DescriptionRow>
  )
}

const DescriptionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 22px;
`

const Separator = styled.span`
  color: rgba(0, 0, 0, 0.25);
`

const GpLabel = styled.span`
  color: rgba(0, 0, 0, 0.45);
`

const NoPricesYet = styled.span`
  color: #6b6b6b;
  font-style: italic;
`

const ListGpBadge = styled.span`
  display: inline-flex;
  align-items: center;

  span {
    margin-left: 0;
    font-size: 12px;
    line-height: 18px;
    padding: 1px 8px;
  }
`

export default RecipeListItemDescription
